import httpClient from './_httpClient';

const END_POINT = '/usersEmail';

const changeEmail = (email) => httpClient.post(END_POINT, {email});
const verifyEmail = (verification_code) => httpClient.put(END_POINT, {verification_code});
const getNewEmailIfExist = () => httpClient.get(END_POINT);
const removeNewEmail = () => httpClient.delete(END_POINT);
const resendVerificationCode = () => httpClient.get(END_POINT + '/resend-verification-code');

export {
  changeEmail,
  verifyEmail,
  getNewEmailIfExist,
  removeNewEmail,
  resendVerificationCode
}
